import { render } from "./App.vue?vue&type=template&id=5fa30764"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5fa30764&lang=css"
import "./App.vue?vue&type=style&index=1&id=5fa30764&lang=css"
script.render = render

export default script